import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import IconUploadAndSelect from '@components/IconUploadAndSelect'

class IconUploader extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    onChange: PropTypes.func,
    onUpload: PropTypes.func,
    showErr: PropTypes.func,
    fetchAddCustomIcon: PropTypes.func,
    fetchCustomIconList: PropTypes.func,
    type: PropTypes.string,
    maxWidth: PropTypes.number,
    maxHeight: PropTypes.number,
    exts: PropTypes.array,
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.data, nextProps.data)) {
      this.setState({
        uploaderUuid: new Date().getTime(),
        url: nextProps.data || ''
      })
    }
  }

  render() {
    const { onUpload, fetchAddCustomIcon, fetchCustomIconList, maxWidth, maxHeight, type, exts } = this.props

    return (
      <IconUploadAndSelect
        {...this.props}
        maxWidth={maxWidth || 64}
        maxHeight={maxHeight || 64}
        mbSize={10}
        onUpload={onUpload}
        fetchAddCustomIcon={fetchAddCustomIcon}
        fetchCustomIconList={fetchCustomIconList}
        onSelected={this.onSelected.bind(this)}
        type={type || 'icon'}
        exts={exts.length > 0 ? exts : ['.png', 'jpg']}
      />
    )
  }

  onSelected(url) {
    this.props.onChange(url)
  }
}

export default IconUploader
